import React from 'react';

const PrintHeader = ({ personal }) => {
  return (
    <div className="hidden print:block mb-8">
      <div className="bg-gradient-to-r from-orange-50 to-amber-50 rounded-3xl p-8 border-2 border-orange-200">
        <div className="text-center">
          <h1 className="text-5xl font-bold text-stone-900 mb-3 tracking-tight">
            {personal.name}
          </h1>
          <h2 className="text-2xl text-orange-600 font-semibold mb-6 tracking-wide">
            {personal.title}
          </h2>
          <div className="flex justify-center items-center flex-wrap gap-6 text-base text-stone-700">
            <div className="flex items-center space-x-2 bg-white/60 px-4 py-2 rounded-full">
              <span className="font-semibold text-orange-600">Email:</span>
              <span>{personal.email}</span>
            </div>
            <div className="flex items-center space-x-2 bg-white/60 px-4 py-2 rounded-full">
              <span className="font-semibold text-orange-600">Phone:</span>
              <span>{personal.phone}</span>
            </div>
          </div>
          <div className="mt-4 text-base text-stone-600 bg-white/60 inline-block px-6 py-2 rounded-full">
            <span className="font-semibold text-orange-600">Location:</span> {personal.location}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintHeader;